export enum DegreeEnum {
    None = 0,
    Bachelors = 1,
    Masters = 2,
    Doctorate = 3,
}
